import Swiper from 'swiper/bundle';

$(function () {
    let el = $('.twitter-feed-swiper');
    if (el.length > 0) {
        new Swiper('.twitter-feed-swiper', {
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            init: true,
            slidesPerView: 1,
            spaceBetween: 110,
            breakpoints: {
                992: {
                    slidesPerView: 2
                },
                1400: {
                    slidesPerView: 3
                }
            },
            watchOverflow: true
        });
    }

    linkTweets($('.twitter-card .card-text'));
});

function linkTweets($tweetText: JQuery) {
    $tweetText.each(function () {
        $(this).html(linkUrls($(this).html()));
        $(this).html(linkHashtags($(this).html()));
        $(this).html(linkMentions($(this).html()));
    });
}

function linkMentions(text: string) {
    const hashtagRegEx = /@([a-zA-Z0-9]+)/g;

    return text.replace(
        hashtagRegEx,
        '<a class="mention" target="_blank" href="https://twitter.com/$1">@$1</a>'
    );
}

function linkHashtags(text: string) {
    const hashtagRegEx = /#([a-zA-Z0-9]+)/g;

    return text.replace(
        hashtagRegEx,
        '<a class="hashtag" target="_blank" href="https://twitter.com/hashtag/$1">#$1</a>'
    );
}

function linkUrls(text: string) {
    const urlRegEx = /https:\/\/([a-zA-Z0-9.a-zA-Z0-9\/]+)/g;

    return text.replace(
        urlRegEx,
        '<a class="link" target="_blank" href="https://$1">$1</a>'
    );
}
